export const toastStyles = {
  // Chakra UI v1.8.8 uses config for default toast options
  // Note: This sets the default, but individual toasts can override
};

